function isNumber(value: any): boolean {
    return typeof value === 'number' && !Number.isNaN(value);
}

export function formatNumber(
    value: number,
    decimalPlaces: number = 0
): string {
    if (!isNumber(value)) {
        console.error('formatNumber: value is not a number', value);
        return 'NaN';
    }
    
    return value
        .toFixed(decimalPlaces)
        .replaceAll(/\B(?=(\d{3})+(?!\d))/g, ',');
}